export default import.meta.ROLLDOWN_FILE_URL_wkqoLAmI6rTNReW38XrkFA